import React, { useState } from "react";
import "./styles.css";

export default function SearchByDate({ handleSearch }) {
  const [searchValue, setSearchValue] = useState("");

  const handleChange = (event) => {
    setSearchValue(event.target.value);
    handleSearch(event.target.value.toLowerCase()); // Converte para minúsculas
  };

  const handleKeyUp = (event) => {
    if (event.target.value === "") {
      handleSearch(""); // Chama handleSearch com valor vazio para renderizar todos os cards
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleSearch(searchValue.toLowerCase()); // Converte para minúsculas
  };

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      <input
      className="input-field"
        type="text"
        value={searchValue}
        onChange={handleChange}
        onKeyUp={handleKeyUp} // Adicionado evento onKeyUp
        placeholder="Pesquisar por data"
      />
      <button className="submit-button" type="submit">Pesquisar</button>
    </form>
  );
}
